var STATUS_INTENTS = {
  active: "success",
  fulfilled: "success",
  finished: "success",
  completed: "success",
  booked: "brand",
  arrived: "brand",
  planned: "brand",
  "in-progress": "attention",
  pending: "attention",
  "no-show": "attention",
  cancelled: "urgent",
  "entered-in-error": "urgent"
};

/** Maps an EMR status string to a semantic intent for chip styling. */
export function statusIntent(status) {
  var _STATUS_INTENTS$statu;
  return (_STATUS_INTENTS$statu = STATUS_INTENTS[status.toLowerCase()]) !== null && _STATUS_INTENTS$statu !== void 0 ? _STATUS_INTENTS$statu : "base";
}

/** Converts a raw EMR status into a human label, e.g. 'in-progress' to 'In progress'. */
export function humanizeStatus(status) {
  var text = status.replace(/[-_]/g, " ").trim();
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
}